import { getPercentFormat } from './locale';

export const localizePercent = (
  val: number,
  maximumFractionDigits = 2,
  locale?: string,
  options?: Intl.NumberFormatOptions,
) => getPercentFormat(maximumFractionDigits, locale, options).format(val);
